// Platform admin API client. Calls the registry-control Worker, not the customer Worker.
// The base URL is the registry-control deployment; in dev it is proxied via vite.config.js.

const BASE = '/platform-api';

async function request(method, path, body) {
  const headers = { 'Content-Type': 'application/json' };
  if (method !== 'GET') {
    const csrf = document.cookie.split('; ').find((entry) => entry.startsWith('paypro_platform_csrf='))?.split('=').slice(1).join('=');
    if (csrf) headers['x-csrf-token'] = decodeURIComponent(csrf);
  }
  const res = await fetch(BASE + path, {
    method,
    headers,
    credentials: 'include',
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const isJson = (res.headers.get('content-type') || '').includes('application/json');
  const data = isJson ? await res.json().catch(() => null) : null;
  if (!res.ok) {
    const err = new Error((data?.error) || res.statusText || 'Request failed');
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const platformApi = {
  changePassword: (body) => request('POST', '/v1/session/password', body),
  // Customers
  listCustomers: () => request('GET', '/v1/customers'),
  getCustomer: (id) => request('GET', `/v1/customers/${id}`),
  createCustomer: (body) => request('POST', '/v1/customers', body),
  setLifecycle: (id, status, actorId) => request('POST', `/v1/customers/${id}/lifecycle`, { status, actorId }),
  updateDeployment: (id, body) => request('POST', `/v1/customers/${id}/deployment`, body),

  // Profiles
  listProfiles: () => request('GET', '/v1/profiles'),
  getProfile: (id) => request('GET', `/v1/profiles/${id}`),
  createProfile: (body) => request('POST', '/v1/profiles', body),
  publishProfile: (id) => request('POST', `/v1/profiles/${id}/publish`, {}),

  // Provisioning jobs
  listJobs: (customerId) => request('GET', `/v1/provisioning-jobs${customerId ? `?customerId=${customerId}` : ''}`),
  getJob: (id) => request('GET', `/v1/provisioning-jobs/${id}`),
  createJob: (body) => request('POST', '/v1/provisioning-jobs', body),

  // Invitations
  createInvitation: (customerId, expiresHours = 72) => request('POST', `/v1/customers/${customerId}/invitations`, { expiresHours }),
  revokeInvitation: (id, actorId) => request('POST', `/v1/invitations/${id}/revoke`, { actorId }),

  // Gateway
  reconcileGateway: (owner = 'platform-ui') => request('POST', '/v1/gateway-reconcile', { owner }),

  // Audit
  listAudit: (params = {}) => {
    const qs = new URLSearchParams();
    if (params.resourceType) qs.set('resourceType', params.resourceType);
    if (params.resourceId) qs.set('resourceId', params.resourceId);
    if (params.limit) qs.set('limit', String(params.limit));
    return request('GET', `/v1/audit${qs.toString() ? '?' + qs : ''}`);
  },
};
